import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingDown } from "lucide-react";

/**
 * CancellationStats — compact horizontal bar chart of the top cancel reasons
 * over the last 30 days. Uses `cancellation_reason_key` captured on the
 * admin cancel modal.
 */
export default function CancellationStats() {
  const [data, setData] = useState(null);
  const [days] = useState(30);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get(`/admin/cancellations/stats?days=${days}`)
      .then(({ data }) => setData(data))
      .catch(() => setData(null));
  }, [days]);

  if (!data || data.total === 0) return null;
  const max = data.reasons[0]?.count || 1;
  const top = data.reasons[0];

  return (
    <section data-testid="cancellation-stats" className="mb-6 border border-line bg-ivory-100/40">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-ivory-100/60 transition-colors"
        data-testid="cancellation-stats-toggle"
      >
        <div className="flex items-center gap-3">
          <TrendingDown className="h-4 w-4 text-rose-600" />
          <div>
            <div className="label-xs text-espresso-light">Cancellations · last {days} days</div>
            <div className="text-sm text-espresso mt-0.5">
              <span className="font-medium">{data.total}</span>
              {" cancelled · top reason "}
              <span className="text-rose-600">{top?.label}</span>
              {top && <span className="text-espresso-light"> ({top.share}%)</span>}
            </div>
          </div>
        </div>
        <span className="label-xs text-espresso-light">{open ? "Hide ▲" : "Show ▼"}</span>
      </button>
      {open && (
        <div className="px-4 pb-4 pt-1 space-y-2 border-t border-line/50" data-testid="cancellation-stats-body">
          {data.reasons.map((r) => (
            <div key={r.key} data-testid={`cancel-reason-row-${r.key}`}>
              <div className="flex items-baseline justify-between text-xs text-espresso mb-1">
                <span>{r.label}</span>
                <span className="text-espresso-light">
                  <span className="text-espresso font-medium">{r.count}</span> · {r.share}%
                </span>
              </div>
              <div className="h-1.5 bg-line/50">
                <div
                  className="h-full bg-rose-500 transition-all"
                  style={{ width: `${(r.count / max) * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
